import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type { AuditLogDto, AuditLogFilter } from "@/features/admin/api/dto";

/**
 * Journal d'audit consolidé paginé (`POST /AuditLogs/all` — les listes
 * sont en POST, guide §4.2). Conserve l'état avant/après de chaque action.
 * Rôles : flashpay-superadmin, flashpay-admin (§6.8).
 */
export const useAuditLogs = (
  params: ListRequest<AuditLogFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN_AUDIT_LOGS_LIST(params),
    queryFn: () =>
      mutateData({
        url: adminEndpoints.auditLogs.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<AuditLogDto>>,
    enabled,
  });
